import styled from 'astroturf/react'
import { useSelector } from 'react-redux'
import { EventLocation } from '@calendly/booking-kit'

import PaymentSummary from 'components/payment/summary'
import { eventSelector, timeNotationSelector } from 'selectors'
import { emailSelector, timezoneSelector } from 'selectors/invitee'
import { chargeSelector } from 'selectors/payment'
import Timezone from 'components/details/timezone'

import Details from './details'
import Marker from './details/marker'
import EventTime from './details/event_time'
import Attendees from './details/attendees'
import _Payment from "confirmation_details-Payment.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/cancellation/cancellation_components/confirmation_details.js?styleId=Payment";


const Payment = /*#__PURE__*/styled(PaymentSummary, null, {
  displayName: "Payment",
  styles: _Payment
})

export const CancellationConfirmationDetails = () => {
  const event = useSelector(eventSelector)
  const email = useSelector(emailSelector)
  const attendeesEmails = [email, ...event.guests]
  const timeNotation = useSelector(timeNotationSelector)
  const timezone = useSelector(timezoneSelector)
  const charge = useSelector(chargeSelector)

  return (
    <div>
      <Details crossedItems>
        <Marker color={event.color} text={event.name} />
        <EventTime
          source={event}
          timezone={timezone}
          timeNotation={timeNotation}
        />
        <Timezone value={timezone} />
        <EventLocation event={event} />
        <Attendees items={attendeesEmails} />
      </Details>
      <Payment charge={charge} />
    </div>
  )
}
